import { ColorKeys, createColorClasses } from "@/theme/colors";
import clsx from "clsx";

export type AvatarSize = "1" | "2" | "3";

type AvatarProps = {
  initials: string;
  bg?: ColorKeys;
  textColor?: ColorKeys;
  size?: AvatarSize;
  className?: string;
};

export const Avatar = ({
  initials,
  bg,
  textColor,
  size = "2",
  className,
}: AvatarProps) => {
  const colorClasses = createColorClasses({
    bg,
    text: textColor,
  });

  const AVATAR_SIZES = {
    "1": "w-x64 h-x64 fs-5",
    "2": "w-x48 h-x48 fs-6",
    "3": "w-x32 h-x32 fs-7",
  };

  const baseClasses = clsx(
    "rounded-full base-row justify-content-center align-items-center p-x4",
    AVATAR_SIZES[size],
    colorClasses,
    className,
  );

  return (
    <div className={baseClasses} aria-hidden="true">
      <span className="fw-semibold">{initials}</span>
    </div>
  );
};
